import React, { useEffect, useRef, useState } from 'react';
import AppIcons from '../../icons';
import FooterMoreBox from '../FooterMoreBox';
import Loader from '../Loader';
import styles from './styles.module.css';
import attachIcon from '../../../../assets/imgs/attachIcon.svg';

export default function FileButton({
  login,
  themeColor,
  loadingFileButton,
  content,
  loadingFile,
  type,
  direction,
  checkIfConnected,
  message,
  onChangeUpload,
  children,
  onClick,
}) {
  const [footerMoreIcon, setFooterMoreIcon] = useState(false);
  const [showFileContent, setShowFileContent] = useState(false);
  const footerMoreRef = useRef(null);
  const contentRef = useRef(null);

  const checkIfClickedOutside = (e) => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (
      footerMoreIcon &&
      footerMoreRef.current &&
      !footerMoreRef.current.contains(e.target)
    ) {
      setFooterMoreIcon(false);
      console.log('firstdepen');
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [showFileContent]);
  const checkIfClickedOutsideContent = (e) => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (
      contentRef &&
      contentRef.current &&
      !contentRef.current.contains(e.target)
    ) {
      setShowFileContent(false);
      console.log('firstdepen');
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOutsideContent);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutsideContent);
    };
  }, [showFileContent]);
  //   useEffect(() => {
  //     if (message?.trim()?.length != 0) {
  //       document.getElementById('fileUploadChat').value = '';
  //     }
  //   }, [message]);
  return (
    <div className={`relative`} onClick={onClick}>
      <div
        className={styles.fileButton}
        onClick={() => {
          setShowFileContent(!showFileContent);
        }}
      >
        {loadingFileButton ? (
          <Loader className={'lds_ring'} width="w-auto" height="h-auto" />
        ) : (
          <img src={attachIcon} />
        )}
      </div>
      {showFileContent && (
        <div
          className={`flex flex-col justify-start items-start themeBox ${
            direction == 'rtl'
              ? styles.fileContentAbsoluteRtl
              : styles.fileContentAbsoluteLtr
          }`}
          ref={contentRef}
        >
          {children}

          <div
            onClick={() => {
              //   setFooterMoreIcon(!footerMoreIcon);
            }}
            className={`relative flex flex-row justify-center items-center`}
          >
            {/* <AppIcons.MoreIcon
              width={`30px`}
              height={'30px'}
              className={`mainColorFill noFilterSvg cursor-pointer`}
            />
            {footerMoreIcon && ( */}
            {/* ============ */}
            {/* <div className={`}  ${styles.boxWidth}`} ref={footerMoreRef}>
              <FooterMoreBox setFooterMoreIcon={setFooterMoreIcon} />
            </div> */}
            {/* ============ */}
            {/* // )} */}
          </div>
          {/* } */}
        </div>
      )}
    </div>
  );
}
